import { useState } from "react";
import styles from "./FAQ.module.css";

export const faqs = [
  {
    id: "question1",
    question: "How can I get matched as a Talent",
    answer: `You can get matched by ensuring you <a href='/register'>signup</a>, fill up all onboarding forms and doing your tests. From there you can search for any job according to your specifications and apply for it. Or you can leave it to us to match you automatically with any client that meets your specifications or that needs you`,
  },
  {
    id: "question2",
    question: "How can I get matched as a Client",
    answer: `As a Client, all you have to do is to <a href='/register'>create an account</a> and <a href='#premium-access'>subscribe</a> to a plan. Fulfill all onboarding pages and processes, then create a job. We will then match you with a talent only if you are on a current pricing plan. But remember that you get a free trial on first signup 😉`,
  },
  {
    id: "question3",
    question: "What job roles are available on Awasource?",
    answer: `For now just these (we hope to add more going forward): software engineers, developers, designers, product managers, product developers, UX designer, architects, project managers, accountants, data analyst, business analyst, financial analyst, marketing manager, product designer, digital marketers, writers, content creators, tutors, artists, visual creators, IT specialists, information security, networking hardware specialist, intern, student-worker`,
  },
  {
    id: "question4",
    question: "What is a Gig?",
    answer: `A role or need that a client is ready to pay a talent to fulfill for a period of 6 months or less`,
  },
  {
    id: "question5",
    question: "What is a Job?",
    answer: `A role or need that a client is ready to pay a talent to fulfill for a period of more than 6 months`,
  },
  {
    id: "question6",
    question: "How diverse is Awasource?",
    answer: `We provide a wide diverse range of talents for clients. We do not exclude any qualified candidates on the basis of race, ethnicity, or gender. We do not show photos, last names, or contact details to reduce bias, until a client matches with a talent.`,
  },
  {
    id: "question7",
    question: "What is KYC?",
    answer: `Know Your Customer (KYC) means confirming an account belongs to who it says it does. Every account confirms its email, and our team reviews each company and talent profile before it goes live.`,
  },
];

function PlusIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function FAQItem({ question, answer, isOpen, onToggle }) {
  return (
    <div className={`${styles.item} ${isOpen ? styles.open : ""}`}>
      <button
        className={styles.question}
        type="button"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <span>{question}</span>
        <span className={styles.icon} aria-hidden="true">
          <PlusIcon />
        </span>
      </button>

      <div className={styles.answer} aria-hidden={!isOpen}>
        <div
          className={styles.answerInner}
          dangerouslySetInnerHTML={{
            __html: answer,
          }}
        ></div>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.sectionHead}>
          <span className={styles.eyebrow}>FAQ</span>
          <h2 className={styles.heading}>Questions, answered.</h2>
        </div>

        <div className={styles.grid}>
          {faqs.map((faq, index) => (
            <FAQItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

// schema.org FAQPage structured data built from the same questions shown on the page.
export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((q) => ({
    "@type": "Question",
    name: q.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: q.answer.replace(/<[^>]*>/g, "").trim(),
    },
  })),
};
